<template>
    <div id="title-section" class="d-flex">
        <div class="text-wrapper d-flex">
            <span>Título da sua avaliação:</span>
        </div>

        <input
            v-model="title"
            :class="{ invalid: invalid }"
            :maxlength="maxChars"
            @change="updateTitle"
        />
        <span class="char-counter">{{ remainingChars }} caracteres restantes</span>
    </div>
</template>

<script>
    export default {
        name: 'TitleSection',
        data() {
            return {
                title: null,
                maxChars: 70,
                invalid: false,
            };
        },

        computed: {
            remainingChars() {
                return this.maxChars - (this.title ? this.title.length : 0);
            },
            isValidTitle() {
                if (!this.title) {
                    this.invalid = true;
                    return false;
                }

                if (this.title.length > this.maxChars) {
                    return false;
                }

                return true;
            },
        },

        methods: {
            updateTitle() {
                if (!this.isValidTitle) {
                    console.log('update');
                    this.invalid = true;
                    return;
                }

                this.$emit('update-form', { field: 'title', value: this.title });
            },
        },
    };
</script>
